import React from 'react'
import CommonAbout from '../CommonComponent/CommonAbout'

export default function About() {
  return (
    <>
    <div className="aboutSpace"></div>
      <CommonAbout/>
    </>
  )
}
